import { render, staticRenderFns } from "./HotTabItem.vue?vue&type=template&id=5bc0667c"
import script from "./HotTabItem.vue?vue&type=script&lang=js"
export * from "./HotTabItem.vue?vue&type=script&lang=js"
import style0 from "./HotTabItem.vue?vue&type=style&index=0&id=5bc0667c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports